// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__6KwgX","tab":"Tabs_tab__3sCBC","tabActive":"Tabs_tabActive__d6dDa"};